import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { cx } from '@wp-g2/styles';
import React from 'react';
import { Button } from '../Button';
import { ColorCircle } from '../ColorCircle';
import * as styles from './ColorControl.styles';

function ColorControl(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'ColorControl'),
      children = _useContextSystem.children,
      className = _useContextSystem.className,
      color = _useContextSystem.color,
      otherProps = _objectWithoutProperties(_useContextSystem, ["children", "className", "color"]);

  var classes = cx(styles.ColorControl, className);
  return /*#__PURE__*/React.createElement(Button, Object.assign({
    className: classes,
    isBlock: true,
    isControl: true,
    isSubtle: true,
    ref: forwardedRef,
    textAlign: "left",
    variant: "tertiary"
  }, otherProps, {
    prefix: /*#__PURE__*/React.createElement(ColorCircle, {
      color: color,
      size: "small"
    })
  }), children);
}

export default contextConnect(ColorControl, 'ColorControl');